/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import './node_modules/bootstrap/dist/css/bootstrap.css'
import i18n from './src/i18n/index'

const LOCALES = ['it', 'en']

function getLocaleFromPath(pathname) {
	const segment = pathname.split('/')[1]
	return LOCALES.includes(segment) ? segment : 'it'
}

// Fire before Gatsby swaps the page — i18n is already set when the new
// component renders, so withTranslation never sees the wrong language.
export const onPreRouteUpdate = ({ location }) => {
	const locale = getLocaleFromPath(location.pathname)
	if (i18n.language !== locale) {
		i18n.changeLanguage(locale)
	}
}

// Handle direct URL visits (initial hydration).
export const onInitialClientRender = () => {
	const locale = getLocaleFromPath(window.location.pathname)
	if (i18n.language !== locale) {
		i18n.changeLanguage(locale)
	}
}
